import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userData: {},
  userType: "EMPY",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    saveUserType(state, action) {
      state.userType = action.payload;
    },
    saveUserData(state, action) {
      state.userData = action.payload;
    },
  },
});

export const { saveUserType, saveUserData } = userSlice.actions;

export default userSlice.reducer;
